import React from 'react';
import { Task } from 'graphql-common';
import { useTaskCompletionsCountQuery } from '@lib/graphql-common';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';
import { ChipTypes } from '@lib/components/Chip/Chip';
import { getInterventionCompletionsFilters } from '@lib/components/TaskCompletions/TaskCompletionsModal/utils/useTaskCompletionsScope';

type Props = {
  task: Task;
  interventionId: string;
  onClick: (task: Task) => void;
};

// The completions this intervention covers, not the whole recurring check's.
export default function TaskCompletionsCell({
  task,
  interventionId,
  onClick,
}: Props) {
  const { data } = useTaskCompletionsCountQuery({
    variables: {
      groupKey: task.groupKey,
      filters: getInterventionCompletionsFilters(interventionId),
    },
    skip: !task.groupKey || !interventionId,
  });
  const totalCount = data?.data.metadata.totalCount;

  if (!totalCount) return '-';

  return (
    <ChipCell
      label={String(totalCount)}
      type={ChipTypes.chipGray}
      onClick={() => onClick(task)}
    />
  );
}
